export const serverProduction = {
    configPollIntervalMs: 60000,
    mlScaleUpHoldSec: 180,
    mlScaleDownHoldSec: 600,
    mlTargetBacklogImageEmbedding: 20,
    mlTargetBacklogImageModeration: 20,
    mlTargetBacklogTextModeration: 20,
    mlTargetBacklogVideoModeration: 2,
    mlTargetWaitMinImageEmbedding: 1,
    mlTargetWaitMinImageModeration: 1,
    mlTargetWaitMinTextModeration: 1,
    mlTargetWaitMinVideoModeration: 1,
};
